export default "__VITE_ASSET__3b6c3c99__"